import gql from 'graphql-tag';
import { kmsClient } from 'api/apollo';
import { useMutation } from '@apollo/react-hooks';
import {
  AccountsOverviewUpdateCampaignMutation,
  AccountsOverviewUpdateCampaignMutationVariables
} from './__generated__/AccountsOverviewUpdateCampaignMutation';

export const ACCOUNTS_OVERVIEW_UPDATE_CAMPAIGN_MUTATION = gql`
  mutation AccountsOverviewUpdateCampaignMutation($id: ID!, $campaignParams: AccountsOverviewCampaignInput!) {
    accountsOverviewUpdateCampaign(id: $id, campaignParams: $campaignParams) {
      success
      errors
    }
  }
`;

export const useAccountsOverviewUpdateCampaignMutation = () => {
  return useMutation<AccountsOverviewUpdateCampaignMutation, AccountsOverviewUpdateCampaignMutationVariables>(
    ACCOUNTS_OVERVIEW_UPDATE_CAMPAIGN_MUTATION,
    { client: kmsClient }
  );
};
